/**
 * Element Plus 图标映射
 * 将字符串图标名称映射为实际的图标组件
 */

import {
  Setting,
  User,
  Menu,
  Monitor,
  House,
  HomeFilled,
  OfficeBuilding,
  UserFilled,
  List,
  Grid,
  Document,
  Link,
  Lock,
  Edit,
  Plus,
  Delete,
  Search,
  Filter,
  Expand,
  Fold,
  Sort,
  Refresh,
  ArrowRight,
  // 补充MenuFormDialog中使用的图标
  Folder,
  Picture,
  Key,
  DataLine,
  Bell,
  Message,
  Star,
  Flag,
  Location,
  Calendar,
  Clock,
  Camera,
  Phone,
  Wallet,
  ShoppingCart,
  Trophy,
  Magnet,
  Compass,
  Tools,
  Printer,
  VideoCamera,
  Microphone,
  Basketball,
  Football,
  Baseball,
  TrendCharts,
  PieChart,
  Histogram,
  ScaleToOriginal,
  FullScreen,
  Share,
  Unlock,
  Warning,
  InfoFilled,
  SuccessFilled,
  CircleCloseFilled,
  QuestionFilled,
  Help,
  More,
  MoreFilled,
  Back,
  Right,
  Top,
  Bottom,
  ArrowLeft,
  ArrowUp,
  DArrowLeft,
  DArrowRight,
  DCaret,
  CaretBottom,
  CaretTop,
  CaretLeft,
  CaretRight,
  SwitchButton,
  Operation,
  Platform,
  Eleme,
  ElemeFilled,
  DeleteFilled,
  Download,
  Upload,
  CircleCheck,
  Promotion,
  Close,
  Check,
  View,
  // 添加更多常用图标
  Loading,
  Service,
  Pointer,
  Notification,
  Connection,
  ChatDotRound,
  Position,
  Discount,
  Odometer,
  ChatSquare,
  ChatRound,
  ChatLineRound,
  ChatLineSquare,
  ChatDotSquare,
  Hide,
  Mute,
  CircleClose,
  CloseBold,
  EditPen,
  MessageBox,
  TurnOff,
  Finished,
  Crop,
  Open,
  Remove,
  ZoomOut,
  ZoomIn,
  WarnTriangleFilled,
  Avatar,
  HelpFilled,
  Comment,
  Rank,
  SortUp,
  SortDown,
  DocumentAdd,
  Notebook,
  Tickets,
  Memo,
  Collection,
  Postcard,
  SetUp,
  DocumentDelete,
  DocumentChecked,
  DataBoard,
  DataAnalysis,
  CopyDocument,
  FolderChecked,
  Files,
  FolderDelete,
  FolderRemove,
  FolderOpened,
  DocumentCopy,
  DocumentRemove,
  FolderAdd,
  FirstAidKit,
  Reading,
  Management,
  VideoPause,
  VideoPlay,
  Headset,
  Film,
  Iphone,
  Cellphone,
  Female,
  Male,
  Aim,
  Minus,
  CirclePlus,
  Select,
  SemiSelect,
  Switch,
  ArrowDown,
  ArrowLeftBold,
  ArrowUpBold,
  ArrowRightBold,
  ArrowDownBold,
  TopRight,
  TopLeft,
  BottomRight,
  BottomLeft,
  Cpu,
  Paperclip
} from '@element-plus/icons-vue'
import type { Component } from 'vue'

/**
 * 图标映射表
 */
export const iconMap: Record<string, Component> = {
  Setting,
  User,
  Menu,
  Monitor,
  House,
  HomeFilled,
  OfficeBuilding,
  UserFilled,
  List,
  Grid,
  Document,
  Link,
  Lock,
  Edit,
  Plus,
  Delete,
  Search,
  Filter,
  Expand,
  Fold,
  Sort,
  Refresh,
  ArrowRight,
  // MenuFormDialog中使用的图标
  Folder,
  Picture,
  Key,
  DataLine,
  Bell,
  Message,
  Star,
  Flag,
  Location,
  Calendar,
  Clock,
  Camera,
  Phone,
  Wallet,
  ShoppingCart,
  Trophy,
  Magnet,
  Compass,
  Tools,
  Printer,
  VideoCamera,
  Microphone,
  Basketball,
  Football,
  Baseball,
  TrendCharts,
  PieChart,
  Histogram,
  ScaleToOriginal,
  FullScreen,
  Share,
  Unlock,
  Warning,
  InfoFilled,
  SuccessFilled,
  CircleCloseFilled,
  QuestionFilled,
  Help,
  More,
  MoreFilled,
  Back,
  Right,
  Top,
  Bottom,
  ArrowLeft,
  ArrowUp,
  DArrowLeft,
  DArrowRight,
  DCaret,
  CaretBottom,
  CaretTop,
  CaretLeft,
  CaretRight,
  SwitchButton,
  Operation,
  Platform,
  Eleme,
  ElemeFilled,
  DeleteFilled,
  Download,
  Upload,
  CircleCheck,
  Promotion,
  Close,
  Check,
  View,
  // 新增的常用图标
  Loading,
  Service,
  Pointer,
  Notification,
  Connection,
  ChatDotRound,
  Position,
  Discount,
  Odometer,
  ChatSquare,
  ChatRound,
  ChatLineRound,
  ChatLineSquare,
  ChatDotSquare,
  Hide,
  Mute,
  CircleClose,
  CloseBold,
  EditPen,
  MessageBox,
  TurnOff,
  Finished,
  Crop,
  Open,
  Remove,
  ZoomOut,
  ZoomIn,
  WarnTriangleFilled,
  Avatar,
  HelpFilled,
  Comment,
  Rank,
  SortUp,
  SortDown,
  DocumentAdd,
  Notebook,
  Tickets,
  Memo,
  Collection,
  Postcard,
  SetUp,
  DocumentDelete,
  DocumentChecked,
  DataBoard,
  DataAnalysis,
  CopyDocument,
  FolderChecked,
  Files,
  FolderDelete,
  FolderRemove,
  FolderOpened,
  DocumentCopy,
  DocumentRemove,
  FolderAdd,
  FirstAidKit,
  Reading,
  Management,
  VideoPause,
  VideoPlay,
  Headset,
  Film,
  Iphone,
  Cellphone,
  Female,
  Male,
  Aim,
  Minus,
  CirclePlus,
  Select,
  SemiSelect,
  Switch,
  ArrowDown,
  ArrowLeftBold,
  ArrowUpBold,
  ArrowRightBold,
  ArrowDownBold,
  TopRight,
  TopLeft,
  BottomRight,
  BottomLeft,
  Cpu,
  Paperclip
}

/**
 * 根据图标名称获取图标组件
 * @param iconName 图标名称
 * @returns 图标组件或null
 */
export const getIconComponent = (iconName: string): Component | null => {
  return iconMap[iconName] || null
}

/**
 * 检查图标是否存在
 * @param iconName 图标名称
 * @returns 是否存在
 */
export const hasIcon = (iconName: string): boolean => {
  return iconName in iconMap
}
